const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "公司介紹",
    "termsOfService": "使用條款",
    "privacyPolicy": "個人資料保護政策",
    "guaranteeOfRights": "個人資料權益保障",
    "customerSupport": "顧客支援",
    "cookiePolicy": "Cookie政策",
    "declarationOfSafety": "安心・安全宣言",
    "youthProtectionPolicy": "青少年保護政策",
    "communityPolicy": "社群政策",
    "probability": "probability",
    "operationPolicy": "營運政策",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "服務合約書",
    "termsOfUse": "會員規範",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "同意NC服務通知",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "根據遊戲相關法令之附加標記",
    "brandInformation": "企業資訊",
    "copyright": "版權",
    "channelingInfo": "（株）NC是通訊販售仲介平台，提供plaync內共享使用管道的遊戲之媒介服務，並非通訊販售當事業者。<br>與提供共享使用管道遊戲相關的全數義務和責任，均由各別通訊販售業者承擔，本公司對與此相關的任何問題概不負責。"
  },
  "infoCS": {
    "businessInformation": "確認企業資訊",
    "infoAddress": "企業：（株）NC 共同代表：金澤辰、朴炳武 營業執照編號：220-81-43000 E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "住址 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea 客服電話 +82-1600-0020 傳真 +82-2-2186-3550",
    "pc": "住址 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea 客服電話 +82-1600-0020 傳真 +82-2-2186-3550",
    "ncfamilyzone": "住址 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea 客服電話 +82-1600-0020 傳真 +82-2-2186-3550",
    "other": "住址 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea 客服電話 +82-1600-0020 傳真 +82-2-2186-3550",
    "none": "",
    "infoEmail": "電子郵件",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC遊戲)/MobileCS@ncsoft.com/(手機遊戲)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "標題",
    "jpGenre": "類型",
    "jpPrice": "價格",
    "jpPriceValue": "免費 (遊戲內另提供付費商品)",
    "jpOs": "對應OS",
    "jpPlatform": "平台",
    "jpDevelopedBy": "開發商／營運商",
    "jpReleaseDay": "發行日",
    "jpReleaseDayValue_LW": "2021年11月04日"
  },
  "country": {
    "KR": "韓國",
    "TW": "台灣",
    "RU": "俄羅斯",
    "MY": "馬來西亞",
    "SA": "沙烏地阿拉伯",
    "SG": "新加坡",
    "AE": "阿拉伯聯合大公國",
    "ID": "印尼",
    "JP": "日本",
    "QA": "卡達",
    "TH": "泰國",
    "PH": "菲律賓",
    "HK": "香港",
    "UA": "烏克蘭",
    "BY": "白俄羅斯",
    "LT": "立陶宛 ",
    "PL": "波蘭",
    "GR": "希臘",
    "IL": "以色列",
    "KW": "科威特",
    "AT": "奧地利",
    "US": "美國",
    "CA": "加拿大",
    "DE": "德國",
    "GB": "英國",
    "FR": "法國",
    "BR": "巴西",
    "IT": "義大利",
    "ES": "西班牙",
    "CL": "智利",
    "NO": "挪威",
    "SE": "瑞典",
    "IE": "愛爾蘭",
    "PT": "葡萄牙",
    "FI": "芬蘭",
    "DK": "丹麥",
    "CH": "瑞士",
    "AR": "阿根廷",
    "PE": "秘魯",
    "MX": "墨西哥",
    "KZ": "哈薩克斯坦",
    "UZ": "烏茲別克斯坦",
    "AZ": "阿塞拜疆",
    "GE": "喬治亞州",
    "MD": "摩爾多瓦",
    "AM": "亞美尼亞",
    "MO": "澳門",
    "IN": "印度",
    "PK": "巴基斯坦",
    "NL": "荷蘭",
    "RO": "羅馬尼亞",
    "AU": "澳洲",
    "TR": "土耳其",
    "EC": "厄瓜多",
    "CO": "哥倫比亞",
    "ZA": "南非",
    "EG": "埃及",
    "NC": "Global"
  }
};

export default l10n;
